<app-sidebar></app-sidebar>
<main class="dashboard-main">
  <div class="dashboard-content">
    <h1 class="dashboard-title">
      {{ userType === 'admin' || userType === 'super_admin' ? 'Admin Dashboard' :
      userType === 'distributor' ? 'Distributor Dashboard' :
      'Staff Dashboard' }}
    </h1>
    <div class="dashboard-welcome">Welcome back! Here's what's happening with your business.</div>
    <section class="dashboard-cards">
      <app-dashboard-card *ngFor="let card of cards" [title]="card.title" [value]="card.value" [sub]="card.sub"
        [icon]="card.icon">
      </app-dashboard-card>
    </section>

    <!-- <section class="dashboard-row">
      <div class="dashboard-info-card activities">
        <div class="card-header">
          <div class="info-title">Recent Activities</div>
          <div class="info-sub">Latest system activities and updates</div>
        </div>
        <ul class="activity-list">
          <li><span class="dot green"></span> <span class="activity-main">New distributor registered</span><span class="activity-time">2 hours ago</span></li>
          <li><span class="dot blue"></span> <span class="activity-main">Invoice #INV-001 paid</span><span class="activity-time">4 hours ago</span></li>
          <li><span class="dot orange"></span> <span class="activity-main">Purchase limit updated for retailer</span><span class="activity-time">6 hours ago</span></li>
        </ul>
      </div>
      <div class="dashboard-info-card health">
        <div class="card-header">
          <div class="info-title">System Health</div>
          <div class="info-sub">Current system status and performance</div>
        </div>
        <div class="health-list">
          <div><span class="health-label">Server Status</span><span class="health-value green">Online</span></div>
          <div><span class="health-label">Database</span><span class="health-value green">Healthy</span></div>
          <div><span class="health-label">Payment Gateway</span><span class="health-value green">Active</span></div>
          <div><span class="health-label">API Response Time</span><span class="health-value blue">120ms</span></div>
        </div>
      </div>
    </section> -->
  </div>
</main>